module.exports = __webpack_public_path__ + "static/media/LOGO FERNANDES(com nome)_2.1f39f910.png";